import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkWhitereact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 23,
	viewBox: "0 0 32 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.78906 11.4998L11.4275 20.1376L28.5653 3",
		stroke: "white",
		strokeWidth: 5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckmarkWhitereact;
